exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-xs[data-v-e4a5b424]{padding:.15rem .4rem;font-size:.75rem;line-height:1.2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e4a5b424","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/allModuleForm/components/OldExpenseAdditionalTask.vue
// module id = 1827
// module chunks = 0